namespace('IO.Views.PaymentDevices', function (exports) {
  'use strict';

  exports.Show = IO.Views.PaymentDevices.New;
});
